module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-easel-2a952869.svg";